import { Component, Input, Optional, Inject, forwardRef } from "@angular/core";
import { FormGroup, AbstractControl } from "@angular/forms";
import { DsStepperComponent } from "../ds-stepper/ds-stepper.component";
import { StepperState } from "../types/stepper.types";

@Component({
  selector: "ds-step",
  templateUrl: "./ds-step.component.html",
  styleUrls: ["./ds-step.component.scss"],
})
export class DsStepComponent {
  @Input() label: string = "";
  @Input() stepControl?: FormGroup | AbstractControl;
  @Input() set completed(value: boolean) {
    this._completed = value;
    this._hasCustomCompletedBinding = true;
  }
  get completed(): boolean {
    return this._completed;
  }
  private _completed: boolean = false;
  @Input() error: boolean = false;
  @Input() editable: boolean = true;
  @Input() disabled: boolean = false;
  state: StepperState = "number";

  private _hasCustomCompletedBinding: boolean = false;

  stepIndex: number = 0;
  isSelected: boolean = false;
  isCompleted: boolean = false;
  isEditable: boolean = true;
  isDisabled: boolean = false;

  constructor(@Optional() @Inject(forwardRef(() => DsStepperComponent)) private stepper?: DsStepperComponent) {}

  get displayLabel(): string {
    return this.label;
  }

  get isStepValid(): boolean {
    if (!this.stepControl) {
      return true;
    }
    return this.stepControl.valid;
  }

  get isStepTouched(): boolean {
    if (!this.stepControl) {
      return false;
    }
    return this.stepControl.touched;
  }

  get isStepDirty(): boolean {
    if (!this.stepControl) {
      return false;
    }
    return this.stepControl.dirty;
  }

  get hasStepError(): boolean {
    return this.error || (!this.isStepValid && this.isStepTouched);
  }

  get stepState(): StepperState {
    if (this.hasStepError) {
      return "error";
    }
    if (this.isCompleted && !this.isSelected) {
      return "done";
    }
    if (this.isSelected) {
      return "number";
    }
    return "number";
  }

  get stepNumber(): number {
    return this.stepIndex + 1;
  }

  get canGoNext(): boolean {
    if (!this.stepper) {
      return false;
    }

    if (this.stepper.navigationMode === "sequential") {
      return this.isStepValid;
    }

    return true;
  }

  get canGoPrevious(): boolean {
    if (!this.stepper) {
      return false;
    }

    return this.stepIndex > 0;
  }

  goNext() {
    if (this.canGoNext && this.stepper) {
      this.stepper.next();
    }
  }

  goPrevious() {
    if (this.canGoPrevious && this.stepper) {
      this.stepper.previous();
    }
  }

  reset() {
    if (this.stepper) {
      this.stepper.reset();
    }
  }

  get hasCustomCompletedBinding(): boolean {
    return this._hasCustomCompletedBinding;
  }
}
